import React from "react";
import { Button, Input, Popup } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { textFilterPlaceholder } from "../config/copy";
import "./SortOptions.css";

const button = (handleClick, locations) => (option) => {
    const active = locations.includes(option.value) || option.selected;

    const trigger = (
        <Button
            className="bg color3 color1"
            active={active}
            onClick={!active ? () => handleClick(option) : undefined}
      compact
      basic
      style={{ cursor: active ? "auto" : "pointer" }}
      as={Link}
      to={option.value}
    >
      {option.text}
    </Button>
  );if (!option.tooltip) {
        return React.cloneElement(trigger, { key: option.text });
    }

    return (
        <Popup
            content={option.tooltip}
            key={option.text}
            basic
            trigger={trigger}
            style={{
                borderRadius: 0.5,
                opacity: 0.9,
                padding: '.5em',
                backgroundColor: 'gray',
                color: 'white',
                fontSize: '0.8em',
            }}
        />
    );
};

const SortOptions = ({
  content,
  order,
  view,
  handleClick,
  location,
  attributeLink,
  showTextFilter,
  handleSearchChange,
}) => {
  order.options = order.options || [];
  content.options = content.options || [];
  view.options = view.options || [];
  const singleSet =
    order.options.length === 0 ||
    content.options.length === 0 ||
    view.options.length === 0;

  return (
    <div
      id="sort-options"
      className={`${showTextFilter ? "filter" : ""} ${
        singleSet ? "single" : "double"
      }`}
    >
      {content.options.length > 0 && (
        <Button.Group>
          {content.options.length > 0 && (
            <>
              <Button
                className="bg color3 color1"
                compact
                basic
                icon="tag"
                style={{ cursor: "auto" }}
              />
              {content.options.map(
                button(handleClick, [location.pathname, attributeLink])
              )}
            </>
          )}
        </Button.Group>
      )}
      {order.options.length > 0 && (
        <Button.Group>
          {order.options.length > 0 && (
            <>
              <Button
                className="bg color3 color1"
                compact
                basic
                icon="sort"
                style={{ cursor: "auto" }}
              />
              {order.options.map(
                button(handleClick, [location.pathname, attributeLink])
              )}
            </>
          )}
        </Button.Group>
      )}
      {view.options.length > 0 && (
        <Button.Group>
          {view.options.length > 0 && (
            <>
              <Button
                className="bg color3 color1"
                compact
                basic
                icon="eye"
                style={{ cursor: "auto" }}
              />
              {view.options.map(
                button(handleClick, [location.pathname, attributeLink])
              )}
            </>
          )}
        </Button.Group>
      )}
      {showTextFilter && (
        <Input
          size="small"
          icon="search"
          placeholder={textFilterPlaceholder}
          onChange={handleSearchChange}
        />
      )}
    </div>
  );
};

export default SortOptions;
